// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/prebuild.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { Subject } from "./identity_pb.js";

/**
 * PrebuildPhase represents the lifecycle phase of a prebuild
 *
 * @generated from enum gitpod.v1.PrebuildPhase
 */
export enum PrebuildPhase {
  /**
   * PREBUILD_PHASE_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: PREBUILD_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PREBUILD_PHASE_PENDING indicates the prebuild has been created but the environment has not yet started
   *
   * @generated from enum value: PREBUILD_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * PREBUILD_PHASE_STARTING indicates the prebuild is being started
   *
   * @generated from enum value: PREBUILD_PHASE_STARTING = 20;
   */
  STARTING = 20,

  /**
   * PREBUILD_PHASE_RUNNING indicates the prebuild is running and tasks are executing
   *
   * @generated from enum value: PREBUILD_PHASE_RUNNING = 30;
   */
  RUNNING = 30,

  /**
   * PREBUILD_PHASE_STOPPING indicates the prebuild is being stopped after completion
   *
   * @generated from enum value: PREBUILD_PHASE_STOPPING = 40;
   */
  STOPPING = 40,

  /**
   * PREBUILD_PHASE_SNAPSHOTTING indicates the environment has stopped and a snapshot is being created
   *
   * @generated from enum value: PREBUILD_PHASE_SNAPSHOTTING = 50;
   */
  SNAPSHOTTING = 50,

  /**
   * PREBUILD_PHASE_COMPLETED indicates the prebuild completed successfully and the snapshot is available
   *
   * @generated from enum value: PREBUILD_PHASE_COMPLETED = 60;
   */
  COMPLETED = 60,

  /**
   * PREBUILD_PHASE_FAILED indicates the prebuild failed at any stage
   *
   * @generated from enum value: PREBUILD_PHASE_FAILED = 70;
   */
  FAILED = 70,

  /**
   * PREBUILD_PHASE_CANCELLING indicates the prebuild is being cancelled (cleanup in progress)
   *
   * @generated from enum value: PREBUILD_PHASE_CANCELLING = 75;
   */
  CANCELLING = 75,

  /**
   * PREBUILD_PHASE_CANCELLED indicates the prebuild was manually cancelled
   *
   * @generated from enum value: PREBUILD_PHASE_CANCELLED = 80;
   */
  CANCELLED = 80,

  /**
   * PREBUILD_PHASE_DELETING indicates the prebuild is being deleted (cleanup in progress)
   *
   * @generated from enum value: PREBUILD_PHASE_DELETING = 85;
   */
  DELETING = 85,

  /**
   * PREBUILD_PHASE_DELETED indicates the prebuild is being deleted
   *
   * @generated from enum value: PREBUILD_PHASE_DELETED = 90;
   */
  DELETED = 90,
}
// Retrieve enum metadata with: proto3.getEnumType(PrebuildPhase)
proto3.util.setEnumType(PrebuildPhase, "gitpod.v1.PrebuildPhase", [
  { no: 0, name: "PREBUILD_PHASE_UNSPECIFIED" },
  { no: 10, name: "PREBUILD_PHASE_PENDING" },
  { no: 20, name: "PREBUILD_PHASE_STARTING" },
  { no: 30, name: "PREBUILD_PHASE_RUNNING" },
  { no: 40, name: "PREBUILD_PHASE_STOPPING" },
  { no: 50, name: "PREBUILD_PHASE_SNAPSHOTTING" },
  { no: 60, name: "PREBUILD_PHASE_COMPLETED" },
  { no: 70, name: "PREBUILD_PHASE_FAILED" },
  { no: 75, name: "PREBUILD_PHASE_CANCELLING" },
  { no: 80, name: "PREBUILD_PHASE_CANCELLED" },
  { no: 85, name: "PREBUILD_PHASE_DELETING" },
  { no: 90, name: "PREBUILD_PHASE_DELETED" },
]);

/**
 * WarmPoolPhase represents the lifecycle phase of a warm pool
 *
 * @generated from enum gitpod.v1.WarmPoolPhase
 */
export enum WarmPoolPhase {
  /**
   * WARM_POOL_PHASE_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: WARM_POOL_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * WARM_POOL_PHASE_PENDING indicates the warm pool has been created but no snapshot is assigned yet
   *
   * @generated from enum value: WARM_POOL_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * WARM_POOL_PHASE_READY indicates the runner has acknowledged the pool and instances are available
   *
   * @generated from enum value: WARM_POOL_PHASE_READY = 20;
   */
  READY = 20,

  /**
   * WARM_POOL_PHASE_DEGRADED indicates the runner reported a problem with the pool
   *
   * @generated from enum value: WARM_POOL_PHASE_DEGRADED = 30;
   */
  DEGRADED = 30,

  /**
   * WARM_POOL_PHASE_DELETING indicates the warm pool is being deleted and instances are draining
   *
   * @generated from enum value: WARM_POOL_PHASE_DELETING = 40;
   */
  DELETING = 40,

  /**
   * WARM_POOL_PHASE_DELETED indicates the warm pool has been fully cleaned up
   *
   * @generated from enum value: WARM_POOL_PHASE_DELETED = 50;
   */
  DELETED = 50,
}
// Retrieve enum metadata with: proto3.getEnumType(WarmPoolPhase)
proto3.util.setEnumType(WarmPoolPhase, "gitpod.v1.WarmPoolPhase", [
  { no: 0, name: "WARM_POOL_PHASE_UNSPECIFIED" },
  { no: 10, name: "WARM_POOL_PHASE_PENDING" },
  { no: 20, name: "WARM_POOL_PHASE_READY" },
  { no: 30, name: "WARM_POOL_PHASE_DEGRADED" },
  { no: 40, name: "WARM_POOL_PHASE_DELETING" },
  { no: 50, name: "WARM_POOL_PHASE_DELETED" },
]);

/**
 * @generated from message gitpod.v1.CreatePrebuildRequest
 */
export class CreatePrebuildRequest extends Message<CreatePrebuildRequest> {
  /**
   * project_id specifies the project to create a prebuild for
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * environment_class_id specifies which environment class to use for the prebuild.
   * If not specified, uses the project's default environment class.
   *
   * @generated from field: optional string environment_class_id = 2;
   */
  environmentClassId?: string;

  /**
   * spec contains the configuration for creating the prebuild
   *
   * @generated from field: gitpod.v1.PrebuildSpec spec = 3;
   */
  spec?: PrebuildSpec;

  constructor(data?: PartialMessage<CreatePrebuildRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePrebuildRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "spec", kind: "message", T: PrebuildSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePrebuildRequest {
    return new CreatePrebuildRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePrebuildRequest {
    return new CreatePrebuildRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePrebuildRequest {
    return new CreatePrebuildRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePrebuildRequest | PlainMessage<CreatePrebuildRequest> | undefined, b: CreatePrebuildRequest | PlainMessage<CreatePrebuildRequest> | undefined): boolean {
    return proto3.util.equals(CreatePrebuildRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreatePrebuildResponse
 */
export class CreatePrebuildResponse extends Message<CreatePrebuildResponse> {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;

  constructor(data?: PartialMessage<CreatePrebuildResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePrebuildResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild", kind: "message", T: Prebuild },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePrebuildResponse {
    return new CreatePrebuildResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePrebuildResponse {
    return new CreatePrebuildResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePrebuildResponse {
    return new CreatePrebuildResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePrebuildResponse | PlainMessage<CreatePrebuildResponse> | undefined, b: CreatePrebuildResponse | PlainMessage<CreatePrebuildResponse> | undefined): boolean {
    return proto3.util.equals(CreatePrebuildResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPrebuildsRequest
 */
export class ListPrebuildsRequest extends Message<ListPrebuildsRequest> {
  /**
   * pagination contains the pagination options for listing prebuilds
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains the filter options for listing prebuilds
   *
   * @generated from field: gitpod.v1.ListPrebuildsRequest.Filter filter = 2;
   */
  filter?: ListPrebuildsRequest_Filter;

  constructor(data?: PartialMessage<ListPrebuildsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPrebuildsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListPrebuildsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPrebuildsRequest {
    return new ListPrebuildsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPrebuildsRequest {
    return new ListPrebuildsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPrebuildsRequest {
    return new ListPrebuildsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPrebuildsRequest | PlainMessage<ListPrebuildsRequest> | undefined, b: ListPrebuildsRequest | PlainMessage<ListPrebuildsRequest> | undefined): boolean {
    return proto3.util.equals(ListPrebuildsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPrebuildsRequest.Filter
 */
export class ListPrebuildsRequest_Filter extends Message<ListPrebuildsRequest_Filter> {
  /**
   * project_ids filters prebuilds to specific projects
   *
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[] = [];

  /**
   * phases filters prebuilds by their current phase
   *
   * @generated from field: repeated gitpod.v1.PrebuildPhase phases = 2;
   */
  phases: PrebuildPhase[] = [];

  /**
   * triggered_by filters prebuilds by how they were triggered
   *
   * @generated from field: repeated gitpod.v1.PrebuildMetadata.PrebuildTrigger triggered_by = 3;
   */
  triggeredBy: PrebuildMetadata_PrebuildTrigger[] = [];

  /**
   * creator_ids filters prebuilds by who created them
   *
   * @generated from field: repeated string creator_ids = 4;
   */
  creatorIds: string[] = [];

  /**
   * executor_ids filters prebuilds by whose credentials were used to run them
   *
   * @generated from field: repeated string executor_ids = 5;
   */
  executorIds: string[] = [];

  constructor(data?: PartialMessage<ListPrebuildsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPrebuildsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "phases", kind: "enum", T: proto3.getEnumType(PrebuildPhase), repeated: true },
    { no: 3, name: "triggered_by", kind: "enum", T: proto3.getEnumType(PrebuildMetadata_PrebuildTrigger), repeated: true },
    { no: 4, name: "creator_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "executor_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPrebuildsRequest_Filter {
    return new ListPrebuildsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPrebuildsRequest_Filter {
    return new ListPrebuildsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPrebuildsRequest_Filter {
    return new ListPrebuildsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListPrebuildsRequest_Filter | PlainMessage<ListPrebuildsRequest_Filter> | undefined, b: ListPrebuildsRequest_Filter | PlainMessage<ListPrebuildsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListPrebuildsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListPrebuildsResponse
 */
export class ListPrebuildsResponse extends Message<ListPrebuildsResponse> {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * prebuilds are the prebuilds that matched the query
   *
   * @generated from field: repeated gitpod.v1.Prebuild prebuilds = 2;
   */
  prebuilds: Prebuild[] = [];

  constructor(data?: PartialMessage<ListPrebuildsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListPrebuildsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "prebuilds", kind: "message", T: Prebuild, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPrebuildsResponse {
    return new ListPrebuildsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPrebuildsResponse {
    return new ListPrebuildsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPrebuildsResponse {
    return new ListPrebuildsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPrebuildsResponse | PlainMessage<ListPrebuildsResponse> | undefined, b: ListPrebuildsResponse | PlainMessage<ListPrebuildsResponse> | undefined): boolean {
    return proto3.util.equals(ListPrebuildsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetPrebuildRequest
 */
export class GetPrebuildRequest extends Message<GetPrebuildRequest> {
  /**
   * prebuild_id specifies the prebuild to retrieve
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId = "";

  constructor(data?: PartialMessage<GetPrebuildRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPrebuildRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPrebuildRequest {
    return new GetPrebuildRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPrebuildRequest {
    return new GetPrebuildRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPrebuildRequest {
    return new GetPrebuildRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPrebuildRequest | PlainMessage<GetPrebuildRequest> | undefined, b: GetPrebuildRequest | PlainMessage<GetPrebuildRequest> | undefined): boolean {
    return proto3.util.equals(GetPrebuildRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetPrebuildResponse
 */
export class GetPrebuildResponse extends Message<GetPrebuildResponse> {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;

  constructor(data?: PartialMessage<GetPrebuildResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetPrebuildResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild", kind: "message", T: Prebuild },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPrebuildResponse {
    return new GetPrebuildResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPrebuildResponse {
    return new GetPrebuildResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPrebuildResponse {
    return new GetPrebuildResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPrebuildResponse | PlainMessage<GetPrebuildResponse> | undefined, b: GetPrebuildResponse | PlainMessage<GetPrebuildResponse> | undefined): boolean {
    return proto3.util.equals(GetPrebuildResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelPrebuildRequest
 */
export class CancelPrebuildRequest extends Message<CancelPrebuildRequest> {
  /**
   * prebuild_id specifies the prebuild to cancel
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId = "";

  constructor(data?: PartialMessage<CancelPrebuildRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelPrebuildRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPrebuildRequest {
    return new CancelPrebuildRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPrebuildRequest {
    return new CancelPrebuildRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPrebuildRequest {
    return new CancelPrebuildRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPrebuildRequest | PlainMessage<CancelPrebuildRequest> | undefined, b: CancelPrebuildRequest | PlainMessage<CancelPrebuildRequest> | undefined): boolean {
    return proto3.util.equals(CancelPrebuildRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CancelPrebuildResponse
 */
export class CancelPrebuildResponse extends Message<CancelPrebuildResponse> {
  /**
   * @generated from field: gitpod.v1.Prebuild prebuild = 1;
   */
  prebuild?: Prebuild;

  constructor(data?: PartialMessage<CancelPrebuildResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CancelPrebuildResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild", kind: "message", T: Prebuild },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelPrebuildResponse {
    return new CancelPrebuildResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelPrebuildResponse {
    return new CancelPrebuildResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelPrebuildResponse {
    return new CancelPrebuildResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelPrebuildResponse | PlainMessage<CancelPrebuildResponse> | undefined, b: CancelPrebuildResponse | PlainMessage<CancelPrebuildResponse> | undefined): boolean {
    return proto3.util.equals(CancelPrebuildResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeletePrebuildRequest
 */
export class DeletePrebuildRequest extends Message<DeletePrebuildRequest> {
  /**
   * prebuild_id specifies the prebuild to delete
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId = "";

  constructor(data?: PartialMessage<DeletePrebuildRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeletePrebuildRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePrebuildRequest {
    return new DeletePrebuildRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePrebuildRequest {
    return new DeletePrebuildRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePrebuildRequest {
    return new DeletePrebuildRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePrebuildRequest | PlainMessage<DeletePrebuildRequest> | undefined, b: DeletePrebuildRequest | PlainMessage<DeletePrebuildRequest> | undefined): boolean {
    return proto3.util.equals(DeletePrebuildRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeletePrebuildResponse
 */
export class DeletePrebuildResponse extends Message<DeletePrebuildResponse> {
  constructor(data?: PartialMessage<DeletePrebuildResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeletePrebuildResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeletePrebuildResponse {
    return new DeletePrebuildResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeletePrebuildResponse {
    return new DeletePrebuildResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeletePrebuildResponse {
    return new DeletePrebuildResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeletePrebuildResponse | PlainMessage<DeletePrebuildResponse> | undefined, b: DeletePrebuildResponse | PlainMessage<DeletePrebuildResponse> | undefined): boolean {
    return proto3.util.equals(DeletePrebuildResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreatePrebuildLogsTokenRequest
 */
export class CreatePrebuildLogsTokenRequest extends Message<CreatePrebuildLogsTokenRequest> {
  /**
   * prebuild_id specifies the prebuild for which the logs token should be created.
   *
   * +required
   *
   * @generated from field: string prebuild_id = 1;
   */
  prebuildId = "";

  constructor(data?: PartialMessage<CreatePrebuildLogsTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePrebuildLogsTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prebuild_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePrebuildLogsTokenRequest {
    return new CreatePrebuildLogsTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePrebuildLogsTokenRequest {
    return new CreatePrebuildLogsTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePrebuildLogsTokenRequest {
    return new CreatePrebuildLogsTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePrebuildLogsTokenRequest | PlainMessage<CreatePrebuildLogsTokenRequest> | undefined, b: CreatePrebuildLogsTokenRequest | PlainMessage<CreatePrebuildLogsTokenRequest> | undefined): boolean {
    return proto3.util.equals(CreatePrebuildLogsTokenRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreatePrebuildLogsTokenResponse
 */
export class CreatePrebuildLogsTokenResponse extends Message<CreatePrebuildLogsTokenResponse> {
  /**
   * access_token is the token that can be used to access the logs of the prebuild
   *
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  constructor(data?: PartialMessage<CreatePrebuildLogsTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreatePrebuildLogsTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePrebuildLogsTokenResponse {
    return new CreatePrebuildLogsTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePrebuildLogsTokenResponse {
    return new CreatePrebuildLogsTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePrebuildLogsTokenResponse {
    return new CreatePrebuildLogsTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePrebuildLogsTokenResponse | PlainMessage<CreatePrebuildLogsTokenResponse> | undefined, b: CreatePrebuildLogsTokenResponse | PlainMessage<CreatePrebuildLogsTokenResponse> | undefined): boolean {
    return proto3.util.equals(CreatePrebuildLogsTokenResponse, a, b);
  }
}

/**
 * Prebuild represents a prebuild for a project that creates a snapshot
 * for faster environment startup times.
 *
 * @generated from message gitpod.v1.Prebuild
 */
export class Prebuild extends Message<Prebuild> {
  /**
   * id is the unique identifier for the prebuild
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * metadata contains organizational and ownership information
   *
   * @generated from field: gitpod.v1.PrebuildMetadata metadata = 2;
   */
  metadata?: PrebuildMetadata;

  /**
   * spec contains the configuration used to create this prebuild
   *
   * @generated from field: gitpod.v1.PrebuildSpec spec = 3;
   */
  spec?: PrebuildSpec;

  /**
   * status contains the current status and progress of the prebuild
   *
   * @generated from field: gitpod.v1.PrebuildStatus status = 4;
   */
  status?: PrebuildStatus;

  constructor(data?: PartialMessage<Prebuild>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.Prebuild";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: PrebuildMetadata },
    { no: 3, name: "spec", kind: "message", T: PrebuildSpec },
    { no: 4, name: "status", kind: "message", T: PrebuildStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Prebuild {
    return new Prebuild().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Prebuild {
    return new Prebuild().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Prebuild {
    return new Prebuild().fromJsonString(jsonString, options);
  }

  static equals(a: Prebuild | PlainMessage<Prebuild> | undefined, b: Prebuild | PlainMessage<Prebuild> | undefined): boolean {
    return proto3.util.equals(Prebuild, a, b);
  }
}

/**
 * PrebuildMetadata contains metadata about the prebuild
 *
 * @generated from message gitpod.v1.PrebuildMetadata
 */
export class PrebuildMetadata extends Message<PrebuildMetadata> {
  /**
   * organization_id is the ID of the organization that owns the prebuild
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * project_id is the ID of the project this prebuild was created for
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * environment_class_id is the environment class used to create this prebuild.
   * While the prebuild is created with a specific environment class, environments
   * with different classes (e.g., smaller or larger instance sizes) can be created
   * from the same prebuild, as long as they run on the same runner.
   * If not specified in create requests, uses the project's default environment class.
   *
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId = "";

  /**
   * creator is the identity of who created the prebuild.
   * For manual prebuilds, this is the user who triggered it.
   * For scheduled prebuilds, this is the configured executor.
   *
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * created_at is when the prebuild was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the prebuild was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * trigger describes the trigger that created this prebuild.
   *
   * @generated from field: gitpod.v1.PrebuildMetadata.PrebuildTrigger triggered_by = 7;
   */
  triggeredBy = PrebuildMetadata_PrebuildTrigger.UNSPECIFIED;

  /**
   * executor is the identity used to run the prebuild.
   * The executor's SCM credentials are used to clone the repository.
   * If not set, the creator's identity is used.
   *
   * @generated from field: gitpod.v1.Subject executor = 8;
   */
  executor?: Subject;

  constructor(data?: PartialMessage<PrebuildMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PrebuildMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creator", kind: "message", T: Subject },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "triggered_by", kind: "enum", T: proto3.getEnumType(PrebuildMetadata_PrebuildTrigger) },
    { no: 8, name: "executor", kind: "message", T: Subject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrebuildMetadata {
    return new PrebuildMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrebuildMetadata {
    return new PrebuildMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrebuildMetadata {
    return new PrebuildMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: PrebuildMetadata | PlainMessage<PrebuildMetadata> | undefined, b: PrebuildMetadata | PlainMessage<PrebuildMetadata> | undefined): boolean {
    return proto3.util.equals(PrebuildMetadata, a, b);
  }
}

/**
 * PrebuildTrigger indicates how the prebuild was triggered
 *
 * @generated from enum gitpod.v1.PrebuildMetadata.PrebuildTrigger
 */
export enum PrebuildMetadata_PrebuildTrigger {
  /**
   * PREBUILD_TRIGGER_UNSPECIFIED is the default value and should not be used
   *
   * @generated from enum value: PREBUILD_TRIGGER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * PREBUILD_TRIGGER_MANUAL indicates the prebuild was manually triggered by a user
   *
   * @generated from enum value: PREBUILD_TRIGGER_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * PREBUILD_TRIGGER_SCHEDULED indicates the prebuild was triggered by a scheduled job
   *
   * @generated from enum value: PREBUILD_TRIGGER_SCHEDULED = 2;
   */
  SCHEDULED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PrebuildMetadata_PrebuildTrigger)
proto3.util.setEnumType(PrebuildMetadata_PrebuildTrigger, "gitpod.v1.PrebuildMetadata.PrebuildTrigger", [
  { no: 0, name: "PREBUILD_TRIGGER_UNSPECIFIED" },
  { no: 1, name: "PREBUILD_TRIGGER_MANUAL" },
  { no: 2, name: "PREBUILD_TRIGGER_SCHEDULED" },
]);

/**
 * PrebuildSpec contains the configuration used to create a prebuild
 *
 * @generated from message gitpod.v1.PrebuildSpec
 */
export class PrebuildSpec extends Message<PrebuildSpec> {
  /**
   * spec_version is incremented each time the spec is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion = protoInt64.zero;

  /**
   * desired_phase is the desired phase of the prebuild.
   * Used to signal cancellation or other state changes.
   * This field is managed by the API and reconciler.
   *
   * @generated from field: gitpod.v1.PrebuildPhase desired_phase = 2;
   */
  desiredPhase = PrebuildPhase.UNSPECIFIED;

  /**
   * timeout is the maximum time allowed for the prebuild to complete.
   * Defaults to 60 minutes if not specified.
   * Maximum allowed timeout is 2 hours.
   *
   * @generated from field: google.protobuf.Duration timeout = 3;
   */
  timeout?: Duration;

  constructor(data?: PartialMessage<PrebuildSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PrebuildSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spec_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(PrebuildPhase) },
    { no: 3, name: "timeout", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrebuildSpec {
    return new PrebuildSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrebuildSpec {
    return new PrebuildSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrebuildSpec {
    return new PrebuildSpec().fromJsonString(jsonString, options);
  }

  static equals(a: PrebuildSpec | PlainMessage<PrebuildSpec> | undefined, b: PrebuildSpec | PlainMessage<PrebuildSpec> | undefined): boolean {
    return proto3.util.equals(PrebuildSpec, a, b);
  }
}

/**
 * PrebuildStatus contains the current status and progress of a prebuild
 *
 * @generated from message gitpod.v1.PrebuildStatus
 */
export class PrebuildStatus extends Message<PrebuildStatus> {
  /**
   * phase is the current phase of the prebuild lifecycle
   *
   * @generated from field: gitpod.v1.PrebuildPhase phase = 1;
   */
  phase = PrebuildPhase.UNSPECIFIED;

  /**
   * completion_time is when the prebuild completed (successfully or with failure)
   *
   * @generated from field: google.protobuf.Timestamp completion_time = 2;
   */
  completionTime?: Timestamp;

  /**
   * failure_message contains details about why the prebuild failed
   *
   * @generated from field: string failure_message = 3;
   */
  failureMessage = "";

  /**
   * log_url provides access to prebuild logs.
   * During prebuild execution, this references the environment logs.
   * After completion, this may reference archived logs.
   *
   * @generated from field: string log_url = 4;
   */
  logUrl = "";

  /**
   * environment_id is the ID of the environment used to create this prebuild.
   * This field is set when the prebuild environment is created.
   *
   * @generated from field: string environment_id = 5;
   */
  environmentId = "";

  /**
   * status_version is incremented each time the status is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 status_version = 6;
   */
  statusVersion = protoInt64.zero;

  /**
   * warning_message contains warnings from the prebuild environment that indicate something went wrong
   * but the prebuild could still complete. For example, the devcontainer failed to build but the environment
   * is still usable. These warnings will likely affect any environment started from this prebuild.
   *
   * @generated from field: string warning_message = 7;
   */
  warningMessage = "";

  /**
   * snapshot_completion_percentage is the progress of snapshot creation (0-100).
   * Only populated when phase is SNAPSHOTTING and progress is available from the cloud provider.
   * This value may update infrequently or remain at 0 depending on the provider.
   *
   * @generated from field: int32 snapshot_completion_percentage = 8;
   */
  snapshotCompletionPercentage = 0;

  /**
   * snapshot_size_bytes is the size of the snapshot in bytes.
   * Only populated when the snapshot is available (phase is COMPLETED).
   *
   * @generated from field: int64 snapshot_size_bytes = 9;
   */
  snapshotSizeBytes = protoInt64.zero;

  constructor(data?: PartialMessage<PrebuildStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.PrebuildStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phase", kind: "enum", T: proto3.getEnumType(PrebuildPhase) },
    { no: 2, name: "completion_time", kind: "message", T: Timestamp },
    { no: 3, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "log_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "snapshot_completion_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "snapshot_size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrebuildStatus {
    return new PrebuildStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrebuildStatus {
    return new PrebuildStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrebuildStatus {
    return new PrebuildStatus().fromJsonString(jsonString, options);
  }

  static equals(a: PrebuildStatus | PlainMessage<PrebuildStatus> | undefined, b: PrebuildStatus | PlainMessage<PrebuildStatus> | undefined): boolean {
    return proto3.util.equals(PrebuildStatus, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateWarmPoolRequest
 */
export class CreateWarmPoolRequest extends Message<CreateWarmPoolRequest> {
  /**
   * project_id specifies the project this warm pool belongs to.
   * The project must have prebuilds enabled.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * environment_class_id specifies which environment class to warm.
   * Must be listed in the project's prebuild configuration environment_class_ids.
   *
   * @generated from field: string environment_class_id = 2;
   */
  environmentClassId = "";

  /**
   * desired_size is the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   *
   * @generated from field: int32 desired_size = 3 [deprecated = true];
   * @deprecated
   */
  desiredSize = 0;

  /**
   * min_size is the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 4;
   */
  minSize?: number;

  /**
   * max_size is the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 5;
   */
  maxSize?: number;

  constructor(data?: PartialMessage<CreateWarmPoolRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWarmPoolRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "desired_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "min_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "max_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWarmPoolRequest {
    return new CreateWarmPoolRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWarmPoolRequest {
    return new CreateWarmPoolRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWarmPoolRequest {
    return new CreateWarmPoolRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWarmPoolRequest | PlainMessage<CreateWarmPoolRequest> | undefined, b: CreateWarmPoolRequest | PlainMessage<CreateWarmPoolRequest> | undefined): boolean {
    return proto3.util.equals(CreateWarmPoolRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CreateWarmPoolResponse
 */
export class CreateWarmPoolResponse extends Message<CreateWarmPoolResponse> {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;

  constructor(data?: PartialMessage<CreateWarmPoolResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CreateWarmPoolResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool", kind: "message", T: WarmPool },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWarmPoolResponse {
    return new CreateWarmPoolResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWarmPoolResponse {
    return new CreateWarmPoolResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWarmPoolResponse {
    return new CreateWarmPoolResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWarmPoolResponse | PlainMessage<CreateWarmPoolResponse> | undefined, b: CreateWarmPoolResponse | PlainMessage<CreateWarmPoolResponse> | undefined): boolean {
    return proto3.util.equals(CreateWarmPoolResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWarmPoolRequest
 */
export class GetWarmPoolRequest extends Message<GetWarmPoolRequest> {
  /**
   * warm_pool_id specifies the warm pool to retrieve
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId = "";

  constructor(data?: PartialMessage<GetWarmPoolRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWarmPoolRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWarmPoolRequest {
    return new GetWarmPoolRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWarmPoolRequest {
    return new GetWarmPoolRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWarmPoolRequest {
    return new GetWarmPoolRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetWarmPoolRequest | PlainMessage<GetWarmPoolRequest> | undefined, b: GetWarmPoolRequest | PlainMessage<GetWarmPoolRequest> | undefined): boolean {
    return proto3.util.equals(GetWarmPoolRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetWarmPoolResponse
 */
export class GetWarmPoolResponse extends Message<GetWarmPoolResponse> {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;

  constructor(data?: PartialMessage<GetWarmPoolResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetWarmPoolResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool", kind: "message", T: WarmPool },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetWarmPoolResponse {
    return new GetWarmPoolResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetWarmPoolResponse {
    return new GetWarmPoolResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetWarmPoolResponse {
    return new GetWarmPoolResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetWarmPoolResponse | PlainMessage<GetWarmPoolResponse> | undefined, b: GetWarmPoolResponse | PlainMessage<GetWarmPoolResponse> | undefined): boolean {
    return proto3.util.equals(GetWarmPoolResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWarmPoolsRequest
 */
export class ListWarmPoolsRequest extends Message<ListWarmPoolsRequest> {
  /**
   * pagination contains the pagination options for listing warm pools
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains the filter options for listing warm pools
   *
   * @generated from field: gitpod.v1.ListWarmPoolsRequest.Filter filter = 2;
   */
  filter?: ListWarmPoolsRequest_Filter;

  constructor(data?: PartialMessage<ListWarmPoolsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWarmPoolsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "filter", kind: "message", T: ListWarmPoolsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWarmPoolsRequest {
    return new ListWarmPoolsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWarmPoolsRequest {
    return new ListWarmPoolsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWarmPoolsRequest {
    return new ListWarmPoolsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWarmPoolsRequest | PlainMessage<ListWarmPoolsRequest> | undefined, b: ListWarmPoolsRequest | PlainMessage<ListWarmPoolsRequest> | undefined): boolean {
    return proto3.util.equals(ListWarmPoolsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWarmPoolsRequest.Filter
 */
export class ListWarmPoolsRequest_Filter extends Message<ListWarmPoolsRequest_Filter> {
  /**
   * project_ids filters warm pools to specific projects
   *
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[] = [];

  /**
   * environment_class_ids filters warm pools to specific environment classes
   *
   * @generated from field: repeated string environment_class_ids = 2;
   */
  environmentClassIds: string[] = [];

  constructor(data?: PartialMessage<ListWarmPoolsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWarmPoolsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "environment_class_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWarmPoolsRequest_Filter {
    return new ListWarmPoolsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWarmPoolsRequest_Filter {
    return new ListWarmPoolsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWarmPoolsRequest_Filter {
    return new ListWarmPoolsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListWarmPoolsRequest_Filter | PlainMessage<ListWarmPoolsRequest_Filter> | undefined, b: ListWarmPoolsRequest_Filter | PlainMessage<ListWarmPoolsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListWarmPoolsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListWarmPoolsResponse
 */
export class ListWarmPoolsResponse extends Message<ListWarmPoolsResponse> {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * warm_pools are the warm pools that matched the query
   *
   * @generated from field: repeated gitpod.v1.WarmPool warm_pools = 2;
   */
  warmPools: WarmPool[] = [];

  constructor(data?: PartialMessage<ListWarmPoolsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListWarmPoolsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "warm_pools", kind: "message", T: WarmPool, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWarmPoolsResponse {
    return new ListWarmPoolsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWarmPoolsResponse {
    return new ListWarmPoolsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWarmPoolsResponse {
    return new ListWarmPoolsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWarmPoolsResponse | PlainMessage<ListWarmPoolsResponse> | undefined, b: ListWarmPoolsResponse | PlainMessage<ListWarmPoolsResponse> | undefined): boolean {
    return proto3.util.equals(ListWarmPoolsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateWarmPoolRequest
 */
export class UpdateWarmPoolRequest extends Message<UpdateWarmPoolRequest> {
  /**
   * warm_pool_id specifies the warm pool to update
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId = "";

  /**
   * desired_size updates the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   *
   * @generated from field: optional int32 desired_size = 2 [deprecated = true];
   * @deprecated
   */
  desiredSize?: number;

  /**
   * min_size updates the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 3;
   */
  minSize?: number;

  /**
   * max_size updates the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 4;
   */
  maxSize?: number;

  constructor(data?: PartialMessage<UpdateWarmPoolRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWarmPoolRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "desired_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "min_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "max_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWarmPoolRequest {
    return new UpdateWarmPoolRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWarmPoolRequest {
    return new UpdateWarmPoolRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWarmPoolRequest {
    return new UpdateWarmPoolRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWarmPoolRequest | PlainMessage<UpdateWarmPoolRequest> | undefined, b: UpdateWarmPoolRequest | PlainMessage<UpdateWarmPoolRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWarmPoolRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateWarmPoolResponse
 */
export class UpdateWarmPoolResponse extends Message<UpdateWarmPoolResponse> {
  /**
   * @generated from field: gitpod.v1.WarmPool warm_pool = 1;
   */
  warmPool?: WarmPool;

  constructor(data?: PartialMessage<UpdateWarmPoolResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateWarmPoolResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool", kind: "message", T: WarmPool },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWarmPoolResponse {
    return new UpdateWarmPoolResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWarmPoolResponse {
    return new UpdateWarmPoolResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWarmPoolResponse {
    return new UpdateWarmPoolResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWarmPoolResponse | PlainMessage<UpdateWarmPoolResponse> | undefined, b: UpdateWarmPoolResponse | PlainMessage<UpdateWarmPoolResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWarmPoolResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteWarmPoolRequest
 */
export class DeleteWarmPoolRequest extends Message<DeleteWarmPoolRequest> {
  /**
   * warm_pool_id specifies the warm pool to delete
   *
   * @generated from field: string warm_pool_id = 1;
   */
  warmPoolId = "";

  constructor(data?: PartialMessage<DeleteWarmPoolRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWarmPoolRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "warm_pool_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWarmPoolRequest {
    return new DeleteWarmPoolRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWarmPoolRequest {
    return new DeleteWarmPoolRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWarmPoolRequest {
    return new DeleteWarmPoolRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWarmPoolRequest | PlainMessage<DeleteWarmPoolRequest> | undefined, b: DeleteWarmPoolRequest | PlainMessage<DeleteWarmPoolRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWarmPoolRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.DeleteWarmPoolResponse
 */
export class DeleteWarmPoolResponse extends Message<DeleteWarmPoolResponse> {
  constructor(data?: PartialMessage<DeleteWarmPoolResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.DeleteWarmPoolResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWarmPoolResponse {
    return new DeleteWarmPoolResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWarmPoolResponse {
    return new DeleteWarmPoolResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWarmPoolResponse {
    return new DeleteWarmPoolResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWarmPoolResponse | PlainMessage<DeleteWarmPoolResponse> | undefined, b: DeleteWarmPoolResponse | PlainMessage<DeleteWarmPoolResponse> | undefined): boolean {
    return proto3.util.equals(DeleteWarmPoolResponse, a, b);
  }
}

/**
 * WarmPool maintains pre-created environment instances from a prebuild snapshot
 * for near-instant environment startup.
 * One warm pool exists per <project, environment_class> pair.
 *
 * @generated from message gitpod.v1.WarmPool
 */
export class WarmPool extends Message<WarmPool> {
  /**
   * id is the unique identifier for the warm pool
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * metadata contains organizational and ownership information
   *
   * @generated from field: gitpod.v1.WarmPoolMetadata metadata = 2;
   */
  metadata?: WarmPoolMetadata;

  /**
   * spec contains the desired configuration for this warm pool
   *
   * @generated from field: gitpod.v1.WarmPoolSpec spec = 3;
   */
  spec?: WarmPoolSpec;

  /**
   * status contains the current status reported by the runner
   *
   * @generated from field: gitpod.v1.WarmPoolStatus status = 4;
   */
  status?: WarmPoolStatus;

  constructor(data?: PartialMessage<WarmPool>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WarmPool";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: WarmPoolMetadata },
    { no: 3, name: "spec", kind: "message", T: WarmPoolSpec },
    { no: 4, name: "status", kind: "message", T: WarmPoolStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WarmPool {
    return new WarmPool().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WarmPool {
    return new WarmPool().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WarmPool {
    return new WarmPool().fromJsonString(jsonString, options);
  }

  static equals(a: WarmPool | PlainMessage<WarmPool> | undefined, b: WarmPool | PlainMessage<WarmPool> | undefined): boolean {
    return proto3.util.equals(WarmPool, a, b);
  }
}

/**
 * WarmPoolMetadata contains metadata about the warm pool
 *
 * @generated from message gitpod.v1.WarmPoolMetadata
 */
export class WarmPoolMetadata extends Message<WarmPoolMetadata> {
  /**
   * organization_id is the ID of the organization that owns the warm pool
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * project_id is the ID of the project this warm pool belongs to
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * environment_class_id is the environment class whose instances are warmed
   *
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId = "";

  /**
   * runner_id is the runner that manages this warm pool.
   * Derived from the environment class.
   *
   * @generated from field: string runner_id = 4;
   */
  runnerId = "";

  /**
   * created_at is when the warm pool was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the warm pool was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  constructor(data?: PartialMessage<WarmPoolMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WarmPoolMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "environment_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WarmPoolMetadata {
    return new WarmPoolMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WarmPoolMetadata {
    return new WarmPoolMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WarmPoolMetadata {
    return new WarmPoolMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: WarmPoolMetadata | PlainMessage<WarmPoolMetadata> | undefined, b: WarmPoolMetadata | PlainMessage<WarmPoolMetadata> | undefined): boolean {
    return proto3.util.equals(WarmPoolMetadata, a, b);
  }
}

/**
 * WarmPoolSpec contains the desired configuration for a warm pool
 *
 * @generated from message gitpod.v1.WarmPoolSpec
 */
export class WarmPoolSpec extends Message<WarmPoolSpec> {
  /**
   * spec_version is incremented each time the spec is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 spec_version = 1;
   */
  specVersion = protoInt64.zero;

  /**
   * desired_size is the number of warm instances to maintain.
   * Deprecated: Use min_size and max_size instead for dynamic scaling.
   * Existing pools will be migrated to min_size=max_size=desired_size.
   *
   * @generated from field: int32 desired_size = 2 [deprecated = true];
   * @deprecated
   */
  desiredSize = 0;

  /**
   * snapshot_id is the prebuild snapshot to warm up in the pool.
   * Updated by the reconciler when a new prebuild completes for this
   * project and environment class. Empty when no completed prebuild exists yet.
   *
   * @generated from field: optional string snapshot_id = 3;
   */
  snapshotId?: string;

  /**
   * desired_phase is the intended lifecycle phase for this warm pool.
   * Managed by the API and reconciler.
   *
   * @generated from field: gitpod.v1.WarmPoolPhase desired_phase = 4;
   */
  desiredPhase = WarmPoolPhase.UNSPECIFIED;

  /**
   * min_size is the minimum number of warm instances to maintain.
   * The pool will never scale below this value.
   * Must be >= 0 and <= max_size. Set to 0 to allow full scale-down.
   *
   * @generated from field: optional int32 min_size = 5;
   */
  minSize?: number;

  /**
   * max_size is the maximum number of warm instances to maintain.
   * The pool will never scale above this value.
   * Must be >= min_size and <= 20.
   *
   * @generated from field: optional int32 max_size = 6;
   */
  maxSize?: number;

  constructor(data?: PartialMessage<WarmPoolSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WarmPoolSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spec_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "desired_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "desired_phase", kind: "enum", T: proto3.getEnumType(WarmPoolPhase) },
    { no: 5, name: "min_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "max_size", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WarmPoolSpec {
    return new WarmPoolSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WarmPoolSpec {
    return new WarmPoolSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WarmPoolSpec {
    return new WarmPoolSpec().fromJsonString(jsonString, options);
  }

  static equals(a: WarmPoolSpec | PlainMessage<WarmPoolSpec> | undefined, b: WarmPoolSpec | PlainMessage<WarmPoolSpec> | undefined): boolean {
    return proto3.util.equals(WarmPoolSpec, a, b);
  }
}

/**
 * WarmPoolStatus contains the current status of a warm pool as reported by the runner
 *
 * @generated from message gitpod.v1.WarmPoolStatus
 */
export class WarmPoolStatus extends Message<WarmPoolStatus> {
  /**
   * phase is the current phase of the warm pool lifecycle
   *
   * @generated from field: gitpod.v1.WarmPoolPhase phase = 1;
   */
  phase = WarmPoolPhase.UNSPECIFIED;

  /**
   * failure_message contains details about why the warm pool is degraded or failed
   *
   * @generated from field: string failure_message = 2;
   */
  failureMessage = "";

  /**
   * status_version is incremented each time the status is updated.
   * Used for optimistic concurrency control.
   *
   * @generated from field: uint64 status_version = 3;
   */
  statusVersion = protoInt64.zero;

  /**
   * running_instances is the number of running warm instances in the pool,
   * ready to be claimed for near-instant environment startup.
   *
   * @generated from field: int32 running_instances = 4;
   */
  runningInstances = 0;

  /**
   * stopped_instances is the number of pre-provisioned but stopped instances
   * in the pool. When a running instance is claimed, stopped instances are
   * used to backfill the running pool faster than provisioning from scratch.
   * Stopped instances only incur storage costs, allowing a larger total pool
   * at lower cost than keeping all instances running.
   *
   * @generated from field: int32 stopped_instances = 5;
   */
  stoppedInstances = 0;

  /**
   * desired_size is the current target number of instances the autoscaler
   * has decided on. Unlike running_instances, this value is stable and
   * does not fluctuate as instances are claimed and backfilled.
   *
   * @generated from field: int32 desired_size = 6;
   */
  desiredSize = 0;

  constructor(data?: PartialMessage<WarmPoolStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WarmPoolStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phase", kind: "enum", T: proto3.getEnumType(WarmPoolPhase) },
    { no: 2, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "running_instances", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "stopped_instances", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "desired_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WarmPoolStatus {
    return new WarmPoolStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WarmPoolStatus {
    return new WarmPoolStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WarmPoolStatus {
    return new WarmPoolStatus().fromJsonString(jsonString, options);
  }

  static equals(a: WarmPoolStatus | PlainMessage<WarmPoolStatus> | undefined, b: WarmPoolStatus | PlainMessage<WarmPoolStatus> | undefined): boolean {
    return proto3.util.equals(WarmPoolStatus, a, b);
  }
}

